import Character from "../Character";

/**
 * @abstract
 */
export default class CharacterBehavior {
    /**
     * 
     * @param {number} behaviorId 
     */
    constructor(behaviorId) {        
        /**
         * @constant
         * @type {number}
         */
        this.behaviorId = behaviorId;
    }

    /**
     * Applies the behavior, but only if it is appropriate for the current state of the world.
     * @abstract
     * @param {Character} character
     * @return {boolean} True if the behavior was applied.
     */
    applyIfAppropriate(character) {
        return false;
    }

    /**
     * Returns true if this is an 'auto-play' behavior rather than an manual play behavior.
     * @abstract
     * @returns {boolean}
     */
    isAutoPlayBehavior() { 
        return false;        
    }

    /**
     * @abstract
     * @returns {string}
     */
    getName() {
        return 'CharacterBehavior****';
    }
}